import { createSelector } from 'reselect';
import get from 'lodash/get';
import { PROGRAM_VALUE_TYPES } from '../../../constants/props';

export const reqFiltersSelector = state => state.board.reqFilters;
export const filtersSelector = state => state.board.filters;

export const availableFiltersSelector = createSelector(
  filtersSelector,
  filters => get(filters, 'availableFilters', []),
);

export const hasFiltersSelector = createSelector(
  availableFiltersSelector,
  filters => !!get(filters, 'length', 0),
);

export const sendingSelector = createSelector(
  reqFiltersSelector,
  request => get(request, 'sending') || false,
);

export const succeedSelector = createSelector(
  reqFiltersSelector,
  request => get(request, 'succeed') || false,
);

// loading / loaded states
export const loadingStateSelector = createSelector(
  sendingSelector,
  succeedSelector,
  (sending, succeed) => sending && !succeed,
);

export const loadedStateSelector = createSelector(
  sendingSelector,
  succeedSelector,
  hasFiltersSelector,
  (sending, succeed, hasFilters) => !sending && succeed && hasFilters,
);

// filters
export const typeSelector = createSelector(
  filtersSelector,
  filters => get(filters, 'type'),
);

export const programValueSelector = createSelector(
  filtersSelector,
  filters => get(filters, 'programValue'),
);

export const statusSelector = createSelector(
  filtersSelector,
  filters => get(filters, 'status'),
);

export const searchQuerySelector = createSelector(
  filtersSelector,
  filters => get(filters, 'searchQuery'),
);

export const activeFilterSelector = createSelector(
  availableFiltersSelector,
  typeSelector,
  (filters, type) => filters.find(option => option.filterValue === type),
);

export const subFiltersSelector = createSelector(
  activeFilterSelector,
  option => get(option, 'subfilters'),
);

export const hasSubFiltersSelector = createSelector(
  subFiltersSelector,
  subFilters => !!subFilters,
);

export const availableProgramsSelector = createSelector(
  subFiltersSelector,
  subFilters => {
    if (!subFilters) return [];

    const programs = subFilters.filter(
      filter => filter.filterKey === 'program',
    );

    return programs.map(program => {
      let icon;

      switch (program.filterValue) {
        case PROGRAM_VALUE_TYPES.all: {
          icon = 'all-programs';
          break;
        }
        case PROGRAM_VALUE_TYPES.none: {
          icon = 'no-program';
          break;
        }
        default: {
          icon = 'program-filter';
          break;
        }
      }

      return { ...program, icon };
    });
  },
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/filters.js